export default __webpack_public_path__ + "assets/hyper_space.a68801c5.png";